import * as Yup from 'yup';
import { is_account_name_unique, is_wallet_address_unique } from '../../services/account';
// import { isAddress } from '../../utilities/address';
import debounce from 'lodash.debounce';
import Web3 from 'web3';
import { isWalletAddress } from '../../utilities/address';

function addAccountValidation() {
  const schema = Yup.object().shape({
    accountName: Yup.string()
      .required('Account Name is required')
      .test(
        'unique-account-name-test',
        'Account name must be unique.',
        (value, context) => !(context.parent.existing_account_names || []).includes(value)
      )
      .test('unique_name', 'Account name must be unique', async (name) => {
        if (name) {
          const response = await debouncedApiName(name?.trim());
          if (!response) return true;
          return response.data?.data?.unique;
        }
      }),
    accountAddress: Yup.string()
      .required('Account Address is required')
      .test('test-w3address', 'The address is not valid', (value) =>
        Web3.utils.isAddress((value || '').toLowerCase())
      )
      .test(
        'unique-account-address-test',
        'Account address must be unique.',
        (value, context) => !(context.parent.existing_account_addresses || []).includes(value)
      )
      .test('unique_name', 'Account address must be unique', async (address) => {
        if (address) {
          const response = await debouncedApiAddress(address?.trim());
          if (!response) return true;
          return response.data?.data?.unique;
        }
      }).test('is_address', 'The address is not valid', async (address) => {
        return isWalletAddress(address);
      }),
  });
  return schema;
}

const debouncedApiName = debounce(is_account_name_unique, 500);

const debouncedApiAddress = debounce(is_wallet_address_unique, 500);

export { addAccountValidation };
